import React, { useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import IssuedBook from "./Book/IssuedBook";
import ReturnBook from "./Book/ReturnBook";
import TableData from "../../common/TableData";
import { getAllIssue,getAllIssueBookReport } from "../../../services/operations/bookDetais";


function BookHistory() {


  const [issuedBook, setIssuedBook] = useState(true); // for the issued for to student





  return (
    <div>
      <div className="w-full bg-richblack-200 p-3 flex  justify-around rounded-2xl">
        <button
          className={`x lg:p-3 p-1 rounded-3xl font-mulish font-bold  text-xl ${
            issuedBook ? "bg-yellow-25" : "bg-richblack-50 hover:bg-richblack-100"
          }`}
          onClick={() => setIssuedBook(true)}
        >
          Issue  Book{" "}
        </button>
        <button
          className={`x lg:p-3 p-1 rounded-3xl font-mulish font-bold  text-xl ${
            !issuedBook
              ? "bg-yellow-25"
              : "bg-richblack-50 hover:bg-richblack-100"
          }`}
          onClick={() => setIssuedBook(false)}
        >
          Return  Book{" "}
        </button>
      </div>

      {issuedBook ? (
        <IssuedBook issuedBook={issuedBook} />
      ) : (
        <ReturnBook issuedBook={issuedBook} />
      )}
      
      
   

     

    </div>
  );
}

export default BookHistory;
